import { createContext } from "react";

const HotelStaffContext = createContext();

export default HotelStaffContext;
